///<reference path="../../../typings/bootstrap/bootstrap.d.ts"/>
///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="processEditor-module.ts"/>

module ProcessEditor {
    /**
    * Custom popover service for showing and hiding popovers
    * - because the AngularUI version does not work with Angular 1.3 yet
    */
    export class PopoverService {
        public setupPopover(anchorElement: JQuery|string, content: JQuery|string, contentParent: JQuery|string, popoverOptions: IPopoverOptions) {
            var anchor = $(anchorElement);
            var $content;

            if (anchor.data("bs.popover")) {
                // Popover is already bound. No need to bind it again.
                return;
            }

            anchor.popover({
                content: () => $content = $(content), // only init on initial open, so all IDs etc are resolvable
                html: true,
                container: 'body',
                trigger: 'manual',
                placement: popoverOptions.placement || "auto right",
                template:
                    `<div class="popover ${popoverOptions.additionalClasses}">` +
                        '<div class="arrow"></div>' +
                        '<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>' +
                        '<div class="popover-content"></div>' +
                        '</div>'
            }).on('show.bs.popover', (e) => {
                if ($content) {
                    $content.show();
                }

                anchor.addClass("popover-open");

                // close button
                const currentAnchor = $(e.target);
                const currentPopover = currentAnchor.data('bs.popover').tip();
                currentPopover.find('button.close').click(() => {
                    currentAnchor.popover('hide');
                });

                // always stop propagating, just in case the element has two or more popovers defined
                // (e.g.the task node with parameter and error handler popover)
                e.stopPropagation();

            }).on('shown.bs.popover', (e) => {
                popoverOptions.onOpen();
                const currentAnchor = $(e.target);
                const currentPopover = currentAnchor.data('bs.popover').tip();
                currentPopover.resizable({
                    handles: "e"  // only horizontal resize
                });
                e.stopPropagation();
            }).on('hidden.bs.popover', (e) => {
                if ($content) {
                    $content.hide();
                    // re-add the editor to the list
                    $(contentParent).append($content);
                }

                popoverOptions.onClose();
                anchor.removeClass("popover-open");
                e.stopPropagation();
            });
        }

        public openPopover(scopeId: string, anchorElementSelector: string|JQuery) {
            if (this.hidePopovers(scopeId)) {
                // popovers were hidden -> just return so we don't get jitter or wrong data shown
                return;
            }
            const element = this.elementFromSelector(anchorElementSelector);
            element.popover('show');
        }

        /**
         * Reopens an existing popover.
         * This is used to re-render the popover when the task or condition type is changed.
         */
        public reopenPopover(elementSelector: string) {
            const element = this.elementFromSelector(elementSelector);
            // disable animations during reopen to reduce flicker
            const popoverData = <PopoverData>element.data('bs.popover');
            popoverData.options.animation = false;

            element.popover('show');

            // enable animations again
            popoverData.options.animation = true;
        }

        public disablePopover(anchorElement: JQuery) {
            anchorElement.popover('destroy');

            // also remove the click handler from the anchor element,
            // so there are no extra events handled if the popover will be recreated
            anchorElement.off("click");
        }

        /** Hides all visible popovers.
         * @returns {Boolean} true if popovers were visible
         */
        public hidePopovers(scopeSelector: string|JQuery): boolean {
            const scopeElement = this.elementFromSelector(scopeSelector);
            const openNodes = scopeElement.find(".popover-open");
            const popoversVisible = openNodes.length > 0;
            openNodes.popover('hide');
            return popoversVisible;
        }

        /**
         * Tries to locate an element by the selector string. First tries the selector as is, then as a jQuery ID
         * @param elementSelector string with a selector string or node ID
         */
        private elementFromSelector(elementSelector: string|JQuery): JQuery {
            const element = $(elementSelector);
            if (element.length > 0) {
                return element;
            }
            return $(`#${elementSelector}`); // try as ID
        }
    }

    app.service("PopoverService", PopoverService);

    export interface IPopoverCloseCallback {
        (form: JQuery)
    }

    export interface IPopoverOptions {
        onClose: () => void;
        onOpen: () => void;
        additionalClasses?: string;
        placement?: string;
    }
}